/*
 *
 * AdminPage / Gifs / GifMonitor
 *
 * Paginated monitor of all GIF sessions. Backed by GET /api/v3/admin/gifs,
 * which returns the standard pagination envelope { current_page, rows_per_page,
 * page_count, data: [...] } where each row is ADMIN_GET_GIF_SHAPE:
 *   { id, approved, channel: { id, name } }
 * (verified against Api::V3::Admin::GifsController#index + GifMapper). The
 * endpoint accepts only page/per_page — no search/status filters exist on the
 * API yet, so this is pagination-only; a filter UI would need a backend change.
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Table from "components/Table";
import Loader from "components/Loader";
import { useAdminGifs } from "../api/queries";
import { Wrapper, StatusPill } from "./styledComponents";

const columns = [
  { header: "ID", path: "id", width: "100px", noSort: true,
    customRow: (row) => `#${row.id}` },
  { header: "Channel", path: "channel", width: "260px", noSort: true,
    customRow: (row) => row.channel?.name || "—" },
  { header: "Status", path: "approved", width: "140px", noSort: true,
    customRow: (row) => (
      <StatusPill $approved={!!row.approved}>
        {row.approved ? "Approved" : "Pending"}
      </StatusPill>
    ) },
];

const GifMonitor = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { data, isLoading, isError, isFetching } = useAdminGifs({ page });

  const rows = data?.data || [];

  return (
    <Wrapper>
      <h1>GIF Monitor</h1>

      {isLoading ? (
        <div data-testid="gifs-loading">
          <Loader />
        </div>
      ) : isError ? (
        <p className="admin-gifs__error">Couldn’t load GIFs. Try again.</p>
      ) : rows.length === 0 ? (
        <p className="admin-gifs__empty">No GIFs to show.</p>
      ) : (
        <Table
          columns={columns}
          data={rows}
          isFetching={isFetching}
          currentPage={data?.current_page || page}
          pageCount={data?.page_count || 1}
          onPageChange={setPage}
          onRowClick={(row) => navigate(`/admin/gifs/${row.id}`)}
        />
      )}
    </Wrapper>
  );
};

export default GifMonitor;
